import { useQuery } from '@tanstack/react-query';

import { fetchData } from 'src/app/queries';

import { marketingTagsKeys } from './query-key-factory';

export type BaseLocationRequest = {
  LspId: number;
};

export type MarketingTag = {
  MarketingTagId: number;
  TagName: string;
};

export type GetMarketingTagsResult = MarketingTag[];

export function useGetMarketingTagsQuery() {
  return useQuery({
    queryKey: marketingTagsKeys.lists(),
    queryFn: () => fetchData<GetMarketingTagsResult>('api/marketing-campaign/get-marketing-tags'),
  });
}
